export const GET_SIMON_DATA = '/rci/utility/aem/simon';

export const GET_AEM_DASHBOARD_DATA = '/content/panorama/rci/post-wow/@@Country/@@Lang/dashboard.model.json';
export const GET_PAGE_RULES = '/content/rule/query/pagerules';
export const GET_OFFER_DETAILS = '/weeks-offer-details?ajax=true';

export const REGION_DETAILS = '/rcio/utilities/refinements/region-hierarchy/nameDetailById';
export const PLAN_TRIPS_DATA = '/rci/resorts/details';
export const ERROR_PAGE = '/rci/post-wow/@@Country/@@Lang/errors/400.html';
export const PAGE_NOT_FOUND = '/post-wow/@@Country/@@Lang/errors/404'; 

export const UPCOMING_TRIPS = '/rci/utility/aem/upComingTripDetails';
export const FEEDBACK = '/content/experience-fragments/panorama/@@Lang/feedback/master.model.json';

// Mocky for Hotels in Aspot
// export const GET_SIMON_DATA = 'https://run.mocky.io/v3/a5e04452-29f5-441d-9463-61eb6f237a52'
// PLAN TRIPS mock simon
// export const GET_SIMON_DATA = 'https://run.mocky.io/v3/a3dfbcbb-b896-4dd8-a1df-48901a34b8fa';
// Simon for book
// export const GET_SIMON_DATA = 'https://run.mocky.io/v3/53626395-d504-4d23-963a-7cfaaf8df31e';
// PLAN CITIES mock simon
// export const GET_SIMON_DATA = 'https://run.mocky.io/v3/2a1b5984-549e-4158-ac91-6d8787104d15';

// Simon call for PlanTrips Fallback Tripleads component
// export const GET_SIMON_DATA = 'https://run.mocky.io/v3/5dbfc698-9e37-4dae-b708-1b95a35a793b';

// // Simon call for PlanCities Fallback Tripleads component
// export const GET_SIMON_DATA = "https://run.mocky.io/v3/869f8a37-ac24-4887-9222-e00fe29b4a7b";

// Dashboard data with no dream comp and only rules_dream comp
// export const GET_AEM_DASHBOARD_DATA = 'https://run.mocky.io/v3/0c397412-049f-4ee5-a980-1240ef1bf800';
// Dashboard data with both dream and rules_dream comp
// export const GET_AEM_DASHBOARD_DATA = 'https://run.mocky.io/v3/e47bf310-1be8-478f-bd3a-5936d7382e9d';
// Dashboard data with only dream and no rules_dream comp
// export const GET_AEM_DASHBOARD_DATA = 'https://run.mocky.io/v3/37d39b1e-b4b7-40b1-9548-688959abc910';

// Dashboard data with 2 dreams and 2 plan components
// Offer 2 up
// export const GET_OFFER_DETAILS = 'https://run.mocky.io/v3/68f796fa-4ab8-477d-8dba-34991e19cd35';
// Offer 3 up
// export const GET_OFFER_DETAILS = 'https://run.mocky.io/v3/30f06b13-1b3f-4534-a89d-01720eb8b9d1';
// No CTA offers
// export const GET_OFFER_DETAILS = 'https://run.mocky.io/v3/8d5d1ded-3f9c-46af-9778-62f58b2bdc6a';

// Mock data for trips
// export const UPCOMING_TRIPS = 'https://run.mocky.io/v3/749b1ce5-ac2e-41c5-bb7e-fc5f670020fe';
// export const GET_DREAM_COMPONENT = 'https://run.mocky.io/v3/6ca4acf3-b15d-40e0-b56c-0e0cbab33de0';

//Hardcoded Urls
export const TRIP_LEADS_CTA_LINK = 'fromInterstitial=false&typeAheadFlag=true&newSearch=true&id=:xmlId&promo_name=:promoName&promo_creative=aspot&promo_id=:promoId&promo_position=:pos';
export const WEEKS_SEARCH_LIST_VIEW_URL = '/weeks-search/All/list-view';
export const WEKS_SEARCH_EXTRA_VACATION_URL = '/weeks-search/LastCall-ExtraVacation/list-view';

export const WEEKS_EXTRA_VACATION_LIST_VIEW = '/weeks-search/ExtraVacation/list-view';
export const WEEKS_EXCHANGE_LIST_VIEW = '/weeks-search/Exchange/list-view';
export const WEEKS_RENEW_ACCOUNT = "/weeks-account/renew";


export const PLAN_TRIPS_EXTRAVACATION_URL = "/weeks-search/Exchange-LastCall-ExtraVacation/available-units?resortCode=:resortId&exchangePlusInd=false&fromPage=:planFromPage&resortSeqNumber=:planindex&promo_name=NBA_triplead_:resortId&promo_creative=aspot&promo_id=:planFromPage&promo_position=:planindex";
export const PLAN_TRIPS_LAST_CALL_URL = "/weeks-search/Exchange-LastCall-ExtraVacation/available-units?resortCode=:resortId&exchangePlusInd=false&fromPage=:planFromPage&resortSeqNumber=:planindex&promo_name=NBA_triplead_:resortId&promo_creative=aspot&promo_id=:planFromPage&promo_position=:planindex";

export const ARN_CARD_URL = '/post-wow-en_US/air-car-cruise/hotels.page?track1=dashboard&track2=NBA&track3=img:hotels_:propAddress&type=property&property=:propId'

export const UPCOMING_TRIPS_PPRO_URL = '/weeks-order/dashboard/addTPROProtection?promo_name=NBA_TPROA&promo_creative=aspot&promo_id=:promoId&promo_position=1';
export const UPCOMING_TRIPS_GC_URL= '/weeks-order/dashboard/addGuestCertificate?promo_name=NBA_GuestCertA&promo_creative=aspot&promo_id=:promoId&promo_position=2';
export const UPCOMING_TRIPS_OS_URL = '/ongoing-search/weeks/upgrade-booking?promo_name=NBA_ChangeRequestA&promo_creative=aspot&promo_id=:promoId&promo_position=3';
export const UPCOMING_TRIPS_UPGRADE_UNIT_URL = '/weeks-account/vacation-plans/confirmed?promo_name=NBA_ChangeRequestB&promo_creative=aspot&promo_id=:promoId&promo_position=3';
export const UPCOMING_TRIPS_TRAVEL_INSURANCE = 'https://14-0087.travelexinsurance.com/?track1=Dashboard_NBA&track2=Weeks&track3=Travelex';
export const UPCOMING_TRIPS_RESORT_DETAILS = '/resort-directory/resortDetails?resortCode=:resortCode&promo_name=NBA_ResortCard&promo_creative=aspot&promo_id=:promoId&promo_position=1';